import { createContext } from 'react';

import type { MyProfileQuery } from '@/apollo/graphql';

export type UserContextType = {
  me: MyProfileQuery['me'];
  loading: boolean;
};

export const UserContext = createContext<UserContextType | null>(null);
/** @deprecated Use useUser hook instead */
export const withUser = Component => props => (
  <UserContext.Consumer>
    {userObj => <Component {...props} user={userObj} />}
  </UserContext.Consumer>
);
